import React from 'react';
import cn from 'classnames';
import { CloseIcon, CheckmarkerIcon } from "../../Icon";
import styles from './ValidationIcon.module.scss';
const Validation = ({ isSelect, type }) => {
    const className = cn(styles.validationIcon, isSelect && styles.selectMode, type === 'cross' ? styles.cross : styles.checkmark);
    if (type === 'cross') {
        return React.createElement(CloseIcon, { "data-testid": "errorIcon", className: className, size: "small" });
    }
    if (type === 'checkmark') {
        return React.createElement(CheckmarkerIcon, { "data-testid": "checkmarkIcon", className: className, size: "small" });
    }
    return null;
};
export default Validation;
//# sourceMappingURL=ValidationIcon.js.map